import React from 'react';
import styles from './index.module.scss.js';

const EditValue = ({ children, onClick }) => /* @__PURE__ */ React.createElement("button", { type: "button", className: styles["edit-value"], onClick }, children);
EditValue.displayName = "Forms.SecurityVerify.EditValue";

export { EditValue };
//# sourceMappingURL=index.js.map
